<script>
  export let question;
  export let name;
  export let lowerVal;
  export let higherVal;
  export let error;
  export let checked = null;
  // const options = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
</script>

<div class="scale-options{error ? ' form-invalid' : ''}">
  <p>{question}</p>
  <div class="scale-bar-wrapper">
    <p class="lower-value">{lowerVal}</p>
    <p class="higher-value">{higherVal}</p>
    <div class="scale-bar" />
  </div>
  <div class="row form-mb radio-wrapper radio-wrapper-stack">
    <div class="inner-radio-wrapper radio-stack">
      {#each { length: 10 } as _, i}
        <label for={name} class="input-wrapper body">
          <input type="radio" bind:group={checked} value={i + 1} />
          <span class="radio-check" />
          <span class="radio-text">{i + 1}</span>
        </label>
      {/each}
    </div>
  </div>
</div>
